import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="world-footer">
      <span>BẢO TÀNG MỸ THUẬT VIỆT NAM</span>
      <span className="footer-rule" />
      <span>Version 2.0 · Trải nghiệm mẫu</span>
    </footer>
  );
};
